// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2-Hjl","right":"Footer_right__j_rO0","buttons":"Footer_buttons__2ZOiP"};